import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ITEM_ATA.TRANSFERENCIA.HISTORICO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
}
